export default "__VITE_ASSET__5ff7d521__"